import React, { useState, useEffect } from "react";
import { API } from '../../../../utils/api'
import { ComingSoon } from "../../../home/component/products/Products"; 

import ProductCard from "./ProductCard";
import ProductModal from "./ProductModal";

import "./ProductGrid.css";
import "../../../home/component/products/Products.css"; // brings in the .coming-soon / .products-spinner styles ComingSoon uses


const ProductGrid =()=>{


const [products,setProducts]=useState([]);
const [loading,setLoading]=useState(true);
const [selectedProduct,setSelectedProduct]=useState(null);


const productsPerPage=6;

const [currentPage,setCurrentPage]=useState(1);


useEffect(() => {
  fetch(`${API}/api/products`)
    .then(r => r.json())
    .then(d => setProducts(d.products || []))
    .catch(() => setProducts([]))
    .finally(() => setLoading(false))
}, [])


const totalPages=Math.ceil(
    products.length/productsPerPage
);


const startIndex=
(currentPage-1)*productsPerPage;


const displayedProducts=
products.slice(
    startIndex,
    startIndex+productsPerPage
);



return(

<section className="product-grid-section">


{loading && (
  <div className='coming-soon'>
    <div className='products-spinner'></div>
    <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.9rem' }}>Loading products…</p>
  </div>
)}

{!loading && products.length === 0 && <ComingSoon />}

{!loading && products.length > 0 && (

<>

<div className="product-grid">


{
displayedProducts.map((product,index)=>(

<ProductCard
key={product.id}
product={product}
index={index}
onReadMore={()=>
setSelectedProduct(product)
}

/>

))
}


</div>



{/* Pagination */}

{
totalPages > 1 &&

<div className="pagination">


<button
onClick={()=>
setCurrentPage(prev=>Math.max(prev-1,1))
}
disabled={currentPage===1}
>
Prev
</button>



{
Array.from(
{length:totalPages},
(_,index)=>(

<button
key={index}
className={
currentPage===index+1
?"active-page":""
}

onClick={()=>
setCurrentPage(index+1)
}
>

{index+1}

</button>


))
}



<button
onClick={()=>
setCurrentPage(prev=>
Math.min(prev+1,totalPages))
}
disabled={currentPage===totalPages}
>
Next
</button>



</div>

}

</>

)}



{
selectedProduct &&

<ProductModal

product={selectedProduct}

closeModal={()=>
setSelectedProduct(null)
}

/>

}



</section>

)


}


export default ProductGrid;